<div
  class="fixed bottom-0 left-0 right-0 z-[9999] box-border block w-full max-w-full bg-white pb-safe-bottom shadow-mobile-toolbar md:hidden"
>
  <!-- Navigation principale -->
  <div
    class="box-border flex h-mobile-toolbar w-full items-center justify-around px-1 2xs:px-0.5"
  >
    @for (item of mainItems; track item.route) {
      <a
        [routerLink]="item.route"
        class="box-border flex min-h-11 max-w-[20%] flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 rounded-lg border-0 bg-transparent p-2 text-greyscale-600 no-underline transition-all duration-200 ease-mobile hover:bg-greyscale-50 hover:text-primary-600"
        routerLinkActive="!text-primary-600 !bg-primary-50"
        [attr.data-testid]="item.testId || item.label"
      >
        <lucide-icon [name]="item.icon" [size]="24"></lucide-icon>
        <span
          class="mt-0.5 whitespace-nowrap text-center text-[10px] font-medium leading-none max-xs:hidden"
          >{{ item.label | transloco }}</span
        >
      </a>
    }

    <!-- Menu Plus -->
    <button
      class="box-border flex min-h-11 max-w-[20%] flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 rounded-lg border-0 bg-transparent p-2 text-greyscale-600 no-underline transition-all duration-200 ease-mobile hover:bg-greyscale-50 hover:text-primary-600"
      (click)="moreMenu.toggle($event)"
    >
      <lucide-icon name="more-vertical" [size]="24"></lucide-icon>
      <span
        class="mt-0.5 whitespace-nowrap text-center text-[10px] font-medium leading-none max-xs:hidden"
        >{{ "navigation.more" | transloco }}</span
      >
    </button>

    <!-- Profil -->
    <button
      class="box-border flex min-h-11 max-w-[20%] flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 rounded-lg border-0 bg-transparent p-2 text-greyscale-600 no-underline transition-all duration-200 ease-mobile hover:bg-greyscale-50 hover:text-primary-600"
      (click)="profileMenu.toggle($event)"
    >
      <p-avatar
        [image]="currentUser()?.company?.logoUrl || undefined"
        [label]="
          currentUser()?.company?.logoUrl
            ? undefined
            : currentUser()?.initials || 'U'
        "
        size="normal"
        shape="circle"
        [style]="{
          'background-color': 'var(--color-primary-500)',
          color: 'var(--color-white)',
          'font-size': '12px',
          width: '24px',
          height: '24px',
        }"
      ></p-avatar>
      <span
        class="mt-0.5 whitespace-nowrap text-center text-[10px] font-medium leading-none max-xs:hidden"
        >{{ "navigation.profile" | transloco }}</span
      >
    </button>
  </div>
</div>

<!-- Menu Plus (Options secondaires) -->
<p-popover #moreMenu [style]="{ width: '280px' }">
  <div class="py-4">
    <div class="flex items-center justify-between px-4 pb-3">
      <h3
        class="my-0 font-source-sans text-sm font-semibold uppercase tracking-wider text-greyscale-700"
      >
        {{ "navigation.navigationTitle" | transloco }}
      </h3>
      <button
        class="flex h-6 w-6 cursor-pointer items-center justify-center rounded border-0 bg-transparent text-greyscale-500 hover:bg-greyscale-100 hover:text-greyscale-700"
        (click)="moreMenu.hide()"
      >
        <lucide-icon name="x" [size]="16"></lucide-icon>
      </button>
    </div>
    <div class="flex flex-col px-4">
      @for (item of secondaryItems(); track item.route) {
        @if (item.isLocked) {
          <button
            class="-mx-2 flex items-center gap-3 rounded px-2 py-3 text-sm font-normal text-greyscale-500 no-underline transition-all duration-200 ease-mobile hover:bg-greyscale-50 hover:text-primary-600 [&:hover>lucide-icon]:text-primary-600"
            (click)="
              moreMenu.hide(); packLimitationService.openModal(clientFeature)
            "
            [attr.data-testid]="item.testId || item.label"
          >
            <lucide-icon
              name="lock"
              [size]="20"
              class="text-greyscale-500 transition-colors duration-200 ease-out"
            ></lucide-icon>
            <span>{{ item.label | transloco }}</span>
          </button>
        } @else {
          <a
            [routerLink]="item.route"
            class="-mx-2 flex items-center gap-3 rounded px-2 py-3 text-sm font-normal text-greyscale-700 no-underline transition-all duration-200 ease-mobile hover:bg-greyscale-50 hover:text-primary-600 [&:hover_lucide-icon]:text-primary-600"
            (click)="moreMenu.hide()"
            [attr.data-testid]="item.testId || item.label"
          >
            <span class="relative flex shrink-0 items-center justify-center">
              <lucide-icon
                [name]="item.icon"
                [size]="20"
                class="text-greyscale-500 transition-colors duration-200 ease-out"
              ></lucide-icon>
              @if (item.warning) {
                <span
                  class="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-orange-500"
                  role="img"
                  [attr.aria-label]="
                    item.warningLabel ? (item.warningLabel | transloco) : null
                  "
                ></span>
              }
            </span>
            <span>{{ item.label | transloco }}</span>
          </a>
        }
      }
    </div>
  </div>
</p-popover>

<!-- Menu Profil -->
<p-popover #profileMenu [style]="{ width: '250px' }">
  @if (currentUser()) {
    <div class="py-4">
      <div class="flex items-center gap-3 px-4 pb-4">
        <p-avatar
          [image]="currentUser()!.company?.logoUrl || undefined"
          [label]="
            currentUser()!.company?.logoUrl ? undefined : currentUser()!.initials
          "
          size="normal"
          shape="circle"
          [style]="{
            'background-color': 'var(--color-primary-500)',
            color: 'var(--color-white)',
          }"
        ></p-avatar>
        <div class="flex-1">
          <div
            class="mb-0.5 font-source-sans text-sm font-semibold text-greyscale-950"
          >
            {{ currentUser()!.firstName }} {{ currentUser()!.lastName }}
          </div>
          <div class="font-source-sans text-xs font-normal text-greyscale-600">
            {{ currentUser()!.companyName }}
          </div>
        </div>
        <button
          class="flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded border-0 bg-transparent text-greyscale-500 hover:bg-greyscale-100 hover:text-greyscale-700"
          (click)="profileMenu.hide()"
        >
          <lucide-icon name="x" [size]="16"></lucide-icon>
        </button>
      </div>

      <div class="mx-4 mb-4 h-px bg-greyscale-200"></div>

      <div class="flex flex-col">
        <button
          class="flex w-full cursor-pointer items-center gap-2 border-0 bg-transparent px-4 py-3 text-left font-source-sans text-sm font-normal text-greyscale-700 transition-all duration-200 ease-mobile hover:bg-greyscale-50 hover:text-greyscale-900"
          (click)="onAccountClick()"
        >
          <lucide-icon name="user" [size]="16" class="shrink-0"></lucide-icon>
          {{ "navigation.myAccount" | transloco }}
        </button>
        <button
          class="flex w-full cursor-pointer items-center gap-2 border-0 bg-transparent px-4 py-3 text-left font-source-sans text-sm font-normal text-error-600 transition-all duration-200 ease-mobile hover:bg-error-50 hover:text-error-700"
          (click)="onLogoutClick()"
        >
          <lucide-icon
            name="log-out"
            [size]="16"
            class="shrink-0"
          ></lucide-icon>
          {{ "navigation.logout" | transloco }}
        </button>
      </div>
    </div>
  }
</p-popover>
